// extracted by mini-css-extract-plugin
export var trial = "style-module--trial--e060f";
export var trial__btn = "style-module--trial__btn--2e736";
export var trial__btnWrap = "style-module--trial__btn-wrap--0f1fc";
export var trial__content = "style-module--trial__content--28e3e";
export var trial__img = "style-module--trial__img--5b8a5";
export var trial__wrapper = "style-module--trial__wrapper--acd36";